<template>
	<breadcrumb-product></breadcrumb-product>
	<div class="container">
		<div class="row">
			<div class="col-xs-12 col-sm-6 col-md-5 center-img padding-right-mobile">
				<product-detail-images></product-detail-images>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-5">
				<product-detail-general></product-detail-general>
			</div>
			<div class="complements-container">
				<div class="col-xs-12 col-sm-12 col-md-2 reorder-mobile">
					<complements></complements>
					<div  class="complements-mobile"><detail></detail></div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="complements-mobile-hide"><detail></detail></div>
			<h2 class="text-uppercase text-center" v-if="render_randoms.length">También te recomendamos</h2>
			<div class="cards-container recommend">
				<div class="col-sm-2 card-item-home" v-for="product in render_randoms">
					<card :product="product"></card>
				</div>
			</div>
			<!-- <div v-if="!render_randoms.length" class="empty text-center">No hay productos recomendados.</div> -->
		</div>
	</div>
</template>

<style scoped>	
	.col-md-2{
		padding-top: 0;
	}
	@media(max-width: 767px){
		.col-sm-12{
			padding: 20px 15px 0 15px; 
		}
	}
	
	@media (max-width: 500px){
		.item-card{
			width: 95%;
			margin-left: 10px;
		}
	}
	@media (max-width: 998px) {
		.card-item-home:last-child {
			display: none;
	}
}
</style>

<script>
import BreadcrumbProduct from '../components/Admin/Breadcrumb-product.vue';
import ProductDetailImages from '../components/Product/Product-detail-images.vue';
import ProductDetailGeneral from '../components/Product/Product-detail-general.vue';
import Complements from '../components/Product/Complements.vue';
import Detail from '../components/Product/Product-detail-info.vue';
import Card from '../components/Home/Card.vue';
import API from '../store/api';

export default {
	// ---- VUEX ----	

	vuex: {
		getters: {
			randoms: state => state.random_products
		}
	},

	// ---- RENDER ----

	computed: {
		render_randoms () {
			return this.randoms;
		}
	},

	// ---- COMPONENTS ----

	components: {
		BreadcrumbProduct,
		ProductDetailImages,
		ProductDetailGeneral,
		Complements,
		Detail,
		Card,
	},
};
</script>


// WEBPACK FOOTER //
// Product-detail.vue?6d365cd1